// extracted by mini-css-extract-plugin
var _1 = "RecoverPasswordForm-modulehelpText__U06gY AuthHelpText-moduleAuthHelpText__HX0rS";
var _2 = "RecoverPasswordForm-modulelicense__lP2qK AuthLicense-moduleAuthLicense__m52dv";
var _3 = "RecoverPasswordForm-moduletitle__L6aE1 AuthTitle-moduleAuthTitle__VKaTa";
var _4 = "RecoverPasswordForm-modulewithNotifications__wPRR9";
export { _1 as "helpText", _2 as "license", _3 as "title", _4 as "withNotifications" }
